import {
    JsonColor,
    JsonIcon,
    JsonWidgetData,
    mapColor,
    mapDataAvailability,
    mapDate,
    mapDescription,
} from 'adapter/out/client/widgets/data/mappers/common';
import { ColorType, Icon, PeriodType } from 'domain/entity/widgetData';
import SingleKPIData, { SingleKPIComparison } from 'domain/entity/widgets/SingleKPIData';

export type JsonSingleKPIData = JsonWidgetData & {
    data: { units: string; value: string; color: JsonColor; icon: JsonIcon; comparison: JsonSingleKPIComparison };
};

export type JsonSingleKPIComparison = {
    enabled: boolean;
    period: {
        type: PeriodType;
        text: string;
        from: string;
        to: string;
    };
    color: JsonColor;
    value: number;
    ['show_as_percentage']: boolean;
};

export const singleKPIMapper = (json: JsonSingleKPIData): SingleKPIData =>
    new SingleKPIData(
        parseFloat(json.data.value),
        json.data.units,
        mapDataAvailability(json.data_availability),
        mapDescription(json.description),
        mapColor(json.data.color),
        mapIcon(json.data.icon),
        mapComparison(json.data.comparison)
    );

const mapIcon = (jsonIcon: JsonIcon): Icon => ({ key: jsonIcon.key });

const mapComparison = (jsonComparison: JsonSingleKPIComparison): SingleKPIComparison => ({
    enabled: jsonComparison.enabled,
    period: {
        from: jsonComparison.period.from ? mapDate(jsonComparison.period.from) : null,
        to: jsonComparison.period.to ? mapDate(jsonComparison.period.to) : null,
        type: PeriodType[jsonComparison.period.type],
        text: jsonComparison.period.text ? jsonComparison.period.text : null,
    },
    color: { type: ColorType[jsonComparison.color.type], byDefault: jsonComparison.color.by_default },
    value: jsonComparison.value,
    showAsPercentage: jsonComparison.show_as_percentage,
});
